import { render } from "./SubscriptionPage.vue?vue&type=template&id=7abba662&ts=true"
import script from "./SubscriptionPage.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__